/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreatePaymentPermissionRequest,
  FetchUsersForPaymentPermissionFilterRequest,
  GetByUserId1Params,
  GetPaymentPermissionWithDetails,
  PaginatedResponseUserProfileFullResponseUserProfilePagedMeta,
  PaymentPermissionResponse,
  UpdatePaymentPermissionRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class PaymentPermissionV1Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name Create7
   * @request POST:/api/v1/payment-permissions
   */
  create = (data: CreatePaymentPermissionRequest, params: RequestParams = {}) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v1/payment-permissions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/payment-permissions'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name FetchAvailableActiveUsers
   * @request POST:/api/v1/payment-permissions/available-active-users
   */
  fetchAvailableActiveUsers = (
    data: FetchUsersForPaymentPermissionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PaginatedResponseUserProfileFullResponseUserProfilePagedMeta, any>({
      path: `/v1/payment-permissions/available-active-users`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static fetchAvailableActiveUsersPath = '/v1/payment-permissions/available-active-users'
  static fetchAvailableActiveUsersMethod = 'POST'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name Get4
   * @request GET:/api/v1/payment-permissions/{id}
   */
  get = (id: string, params: RequestParams = {}) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v1/payment-permissions/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/payment-permissions/${id}'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name Delete1
   * @request DELETE:/api/v1/payment-permissions/{id}
   */
  delete = (id: string, params: RequestParams = {}) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v1/payment-permissions/${id}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deletePath = '/v1/payment-permissions/${id}'
  static deleteMethod = 'DELETE'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name Update7
   * @request PATCH:/api/v1/payment-permissions/{id}
   * @deprecated
   */
  update = (id: string, data: UpdatePaymentPermissionRequest, params: RequestParams = {}) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v1/payment-permissions/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v1/payment-permissions/${id}'
  static updateMethod = 'PATCH'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name UpdatePaymentPermissionType1
   * @request PATCH:/api/v1/payment-permissions/update/{id}/permission-type/{permissionType}
   */
  updatePaymentPermissionType = (
    id: string,
    permissionType: 'VIEW' | 'PREPARE' | 'RELEASE',
    params: RequestParams = {},
  ) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v1/payment-permissions/update/${id}/permission-type/${permissionType}`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })

  static updatePaymentPermissionTypePath =
    '/v1/payment-permissions/update/${id}/permission-type/${permissionType}'
  static updatePaymentPermissionTypeMethod = 'PATCH'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name List
   * @request GET:/api/v1/payment-permissions/list
   */
  list = (params: RequestParams = {}) =>
    this.http.request<GetPaymentPermissionWithDetails[], any>({
      path: `/v1/payment-permissions/list`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static listPath = '/v1/payment-permissions/list'
  static listMethod = 'GET'
  /**
   * No description
   *
   * @tags payment-permission-v-1-controller
   * @name GetByUserId1
   * @request GET:/api/v1/payment-permissions/by-user-id
   */
  getByUserId = (query: GetByUserId1Params, params: RequestParams = {}) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v1/payment-permissions/by-user-id`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getByUserIdPath = '/v1/payment-permissions/by-user-id'
  static getByUserIdMethod = 'GET'
}
